module.exports = __webpack_public_path__ + "static/media/message.1aef9469.svg";